import React from 'react';
import clsx from 'clsx';

import './CommonRadioButton.scss';

function CommonRadioButton({ isActive, value, label, disabled, onSelect }) {
  const handleSelect = () => {
    !isActive && onSelect(value);
  };

  return (
    <div
      className={clsx(
        'common-radio-button',
        isActive && 'common-radio-button--active',
        disabled && 'common-radio-button--disabled',
      )}
      onClick={handleSelect}
      role='presentation'>
      <div className='common-radio-button_circle'>{isActive && <div className='common-radio-button_mark' />}</div>
      {label && <div className='common-radio-button_label'>{label}</div>}
    </div>
  );
}

export default CommonRadioButton;
